/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HomeNowResponse } from '../models/HomeNowResponse';
import type { MatchScreen } from '../models/MatchScreen';
import { SportEnum } from '../models/SportEnum';
import type { TeamScreen } from '../models/TeamScreen';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ScreenService {
    /**
     * Get Home Now
     * Get the current home data.
     * @param sports
     * @param areaOfInterestId
     * @returns HomeNowResponse Successful Response
     * @throws ApiError
     */
    public static getHomeNowScreenHomeGet(
        sports: SportEnum,
        areaOfInterestId: number,
    ): CancelablePromise<HomeNowResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/screen/home',
            query: {
                'sports': sports,
                'area_of_interest_id': areaOfInterestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Match Screen
     * @param matchId
     * @returns MatchScreen Successful Response
     * @throws ApiError
     */
    public static getMatchScreenScreenMatchMatchIdGet(
        matchId: number,
    ): CancelablePromise<MatchScreen> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/screen/match/{match_id}',
            path: {
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Team Screen
     * @param teamId
     * @returns TeamScreen Successful Response
     * @throws ApiError
     */
    public static getTeamScreenScreenTeamTeamIdGet(
        teamId: number,
    ): CancelablePromise<TeamScreen> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/screen/team/{team_id}',
            path: {
                'team_id': teamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
